<template>
    <b-container class="p-0">
        <b-row class="my-1" v-for="([prop , value], index) in Parameter.getProperties()" :key="prop + index">
                <!-- @Todo : Translate -->
                <b-col cols="3">{{ prop }}</b-col>
                <b-col class="py-2">
                    <b-form-select v-if="prop === 'Layout'" :options="enumLayout" v-model="Parameter[prop]" />
                    <b-form-input v-else-if="typeof value === 'string'" v-model="Parameter[prop]" />
                    <b-form-checkbox v-else-if="prop === 'CheckboxToggle'" v-model="Parameter[prop]" plain />
                </b-col>
            </b-row>
    </b-container>
</template>

<script lang="ts">

    import { Prop, Vue} from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import VueI18n from 'vue-i18n' // translation support
    import locales from "../locales/ParametersItems.json";
    import FieldSet from '../FieldSet';
    import { EnumLayout } from '../Enums/EnumLayout';

    Vue.use(VueI18n);

    @Component({
        i18n: { messages: locales }
    })
	export default class FieldSetModal extends Vue{
        /** Variant de couleur à appliquer sur le composant */
        @Prop({default: () => "secondary"})
		public Variant!: string;

        @Prop()
        public Parameter!: FieldSet;
        
        private enumLayout: {value: string | EnumLayout, text: string}[] = Object.entries(EnumLayout).filter(([key, value]) => typeof value === 'number').map(([key, value]) => ({value: value, text: key}));
    }

</script>

<style scoped>
    :deep(input[type=checkbox]:checked) {
        /** Change la couleur de la checkbox */
        accent-color: var(--Variant) !important;
    }

    :deep(input[type=radio]:checked) {
        /** Change la couleur du bouton radio */
        accent-color: var(--Variant) !important;
    }

    /** Pour que la page active prenne en compte la couleur de Variant */
    :deep(.page-item.active .page-link) {
        background-color: var(--Variant) !important;
    }

    :deep(.page-link:hover) {
        background-color: var(--VariantLight) !important;
    }
</style>